
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Musical Tribute</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm raagas-urvashi section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="sec-title text-center">
                <h2>Unforgettable KK: <span >A Musical Tribute to the Legend </span></h2>
            </div>

            <div class="row">
                <div class="col-lg-7">
                    <p class="text-justify">G H Raisoni Sports & Cultural Foundation to organize a musical tribute event
                        ‘Unforgettable KK’ a
                        musical tribute event honoring the legendary singer Krishna Kumar Kunnath (KK), scheduled to
                        take place on May 31, 2023, at Vasantrao Deshpande Hall in Civil Lines, Nagpur.
                        As we get together to celebrate the remarkable musical journey of the soulful voice of
                        Krishnakumar Kunnath (Loved by generations from 90’s - KK). It’s been a year that we miss this
                        voice. To honor his significant influence on the music industry, his unrelenting devotion to his
                        profession, and the enduring legacy he has left behind, we have planned this musical tribute
                        event. This is all about making sure that his melodies live on eternally in our hearts through
                        the power of music.
                    </p>
                    <p class="text-justify"> With his beautiful voice, KK showcased a special talent for expressing a
                        wide range of human
                        emotions. His interpretations touched the souls of millions of people all around the world as
                        they effortlessly conveyed love, longing, joy, and sadness. Through this event of musical
                        tribute, we hope to relive those emotions, immerse ourselves again in the beauty of his music,
                        and show our love for the emotions he expressed so poignantly. ‘Unforgettable kk’, will provide
                        a platform for fans, admirers, and music lovers to come together, share their love for KK, and
                        commemorate his unparalleled talent and impact on our lives.

                    </p>
                </div>
                <div class="col-md-5">
                    <div class="image-effect-2">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kk.webp" alt="GHRSCF"
                            style="width: 100%;">
                    </div>
                </div>
                <div class="col-md-12">
                    <p class="text-justify"> It is a reminder that music has the
                        power to bridge gaps and foster unity among diverse communities.
                        GHRSCF seeks to keep his spirit alive, to cherish his melodies, and to remind the world of the
                        incredible talent that was KK.
                        Through this event, GHRSCF is providing a platform to RAAH Band.</p>
                    <p class="text-justify"> The Young and talented performers from the RAAH Band, will grace the stage
                        and mesmerize the
                        audience with their soul-stirring performances and enchanting tunes. Music has been a vital part
                        of human life throughout history, providing enjoyment, cultural expression, and emotional
                        comfort. G H Raisoni Sports and Cultural Foundation has been running the Musical Rejuvenation
                        programme throughout many areas, especially in the post-COVID-19 era, in recognition of the
                        healing and revitalizing effects of music. Through the use of music, this programme seeks to
                        improve people's emotions while providing aspiring music groups with a platform to showcase
                        their talents.

                    </p>
                    <p class="text-justify"> RAAH Band, is an Indian pop-rock band, which was founded in 2016 and is
                        presently located in
                        Nagpur, Maharashtra, and has become well-known for its energetic concerts that blend several
                        genres. Their interpretations of classic Bollywood songs have attracted a devoted fan base. The
                        RAAH Band is made up of lead singer Abhishek Dahikar as well as co-singers James Ingole and
                        Ashley Besterwitch. Mayank Ingole (Drummer), Akshay Mundafale (Keyboardist), Nikitesh Moses
                        (Lead Guitarist), and Anant Waghmare (Bassist) on guitar and bass, respectively. The band has
                        had the honour of performing extensively both domestically and overseas alongside acclaimed
                        Bollywood playback vocalist Ami Mishra, who is best known for the song "Hasi Ban Gaye" from the
                        film "Humari Adhuri Kahani." In particular, RAAH Band recently dazzled the Nagpur audience with
                        their opening act for India's top DJ, NUCLEYA.

                    </p>
                    <p class="text-justify"> Abhishek Dahikar, the band's lead singer, is also based in Nagpur,
                        Maharashtra. He is a singer,
                        composer, lyricist, and performer. Despite having a career in civil engineering, music has
                        always been his genuine love. He has been devoted to pursuing a career in music for the past 10
                        years, focusing on producing unique material and making a lasting impression on the music
                        business with his great voice and original melodies. The public adored Abhishek's most recent
                        song, "UMEED," which was published in 2021 and garnered a tonne of support on YouTube and other
                        music streaming services. His recently released song, "TU HAI KAHAN," is another fan favourite.
                        Abhishek's live performances, where he displays his talents on the keyboard, guitar, and unusual
                        instruments like the kazoo, are widely praised.

                    </p>
                    <p class="text-justify"> James Ingole is an accomplished singer-songwriter, composer, and guitarist
                        with a noteworthy
                        15-year musical career. He is currently pursuing Visharad and has professional vocal training
                        from RSL (Rockschool Limited). James has a strong voice, but he also has skill on the guitar and
                        keyboard, which gives his performances more depth and variety.

                    </p>
                    <p class="text-justify"> A talented and aspiring vocalist, Ashley Besterwitch is well known for his
                        capacity to enthral
                        audiences with a wide variety of musical genres. Ashley's exciting performances will get you
                        moving on the dance floor to everything from vintage English standards to foot-tapping Bollywood
                        songs. His amazing vocal range, which enables him to perform songs by well-known singers like
                        Bruno Mars, Michael Jackson, Stevie Wonder, and Ed Sheeran, is particularly noteworthy.

                    </p>
                    <p class="text-justify"> Ashley has performed at a number of famous places, such as the Hard Rock
                        Cafe and the Sonic
                        Music Festival, and is well-known across the nation for his extraordinary talent. He is a
                        self-taught artist who never stops developing and moving listeners with his incredible vocal
                        prowess.

                    </p>
                    <p><strong>Let’s meet you then.</strong></p>

                    <p><b>Topic: Unforgettable KK: A Musical Tribute to the Legend </b></p>
                    <p><b>Date – 31<sup>st </sup> May 2023 </b></p>
                    <!-- <p><b>Time – 5:00 pm - Sharp (Grab your seats before time)</b></p> -->
                    <p><b>Venue: Deshpande Hall, Civil Lines Nagpur</b></p>
                    <a class="btn button--effect-2 mx-2 btn-color"
                        href="https://www.ghrscf.com/register-unforgettable-kk">Register Now for Free</a>



                </div>

            </div>
        </div>

        <div class="border-line-sm"></div>
        <div class="row">
            <!-- <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="media#media_classical"   class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <iframe width="100%" height="230" src="https://drive.google.com/file/d/1069W9_-cBzrBgwDIuB6IXFrKgo9RUBHC/preview"   frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                </div>
            </div>  -->
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="photogallery#unforgettable-kk" class="cmn-button"><span>
                                    View More</span>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-1.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-1.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-1.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-2.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-2.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-2.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-3.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-3.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-3.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-4.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-4.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-4.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-5.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-5.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-5.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-6.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-6.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-6.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-5">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-7 text-end">
                            <!-- <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                    YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a> -->
                        </div>
                    </div>
                    <iframe src="https://drive.google.com/file/d/19tX9uzqJbCiLk_NIFaf_KkJsyJF_ancv/preview" height="230"
                        width="100%"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
